import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useHistory } from 'react-router';
import AmericanExpress from '../Icons/payment/AmericanExpress.png';
import ApplePay from '../Icons/payment/ApplePay.png';
import DinersClub from '../Icons/payment/DinersClub.png';
import Discover from '../Icons/payment/Discover.png';
import GPay from '../Icons/payment/GPay.png';
import JCB from '../Icons/payment/JCB.png';
import Mastercard from '../Icons/payment/Mastercard.png';
import Visa from '../Icons/payment/Visa.png';
import paymentService from '../services/paymentService';
import isvpayWebSocketService from '../services/isvpayWebSocketService';
import logger from '../services/LocalServer/logger';
import localRequest from '../services/LocalServer/localRequest';

export default function PaymentPrompt(props) {
  const PAYMENT_METHOD = localStorage.getItem('PAYMENT_METHOD');
  const [one, setone] = useState(true);
  const [allowback, setallowback] = useState(true);
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  let history = useHistory();
  const { t } = useTranslation();
  const machineID = props.id;
  const intervalRef = useRef(null);

  // 设置默认的ISVPay 配置
  if (!localStorage.getItem('ISVPAY_TERMINAL_ID')) {
    localStorage.setItem('ISVPAY_TERMINAL_ID', '6037001');
  }
  if (!localStorage.getItem('ISVPAY_SDK_MODE')) {
    localStorage.setItem('ISVPAY_SDK_MODE', 'TEST'); // 可选: LIVE, TEST, DEV
  }

  const [message, setMessage] = useState(t('Tap or Insert your card'));
  const idleCounterRef = useRef(0);

  let separateItem = JSON.parse(localStorage.getItem('SeparateItem'));
  const mobile_pay = localStorage.getItem('MOBILE_PAY') === 'TRUE';
  let paymentMethod = 2;

  const AE_PAY = localStorage.getItem('AE_PAY') === 'TRUE';
  const DC_PAY = localStorage.getItem('DC_PAY') === 'TRUE';
  const DIS_PAY = localStorage.getItem('DIS_PAY') === 'TRUE';
  const JCB_PAY = localStorage.getItem('JCB_PAY') === 'TRUE';

  if (mobile_pay) {
    paymentMethod++;
    paymentMethod++;
  }
  if (AE_PAY) {
    paymentMethod++;
  }
  if (DC_PAY) {
    paymentMethod++;
  }
  if (DIS_PAY) {
    paymentMethod++;
  }
  if (JCB_PAY) {
    paymentMethod++;
  }

  const prods = separateItem.map((prod, i) => {
    let url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${prod.picture}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;

    if (prod.prodType === 'fridge1' || prod.prodType === 'fridge2') {
      url = isLocal
        ? `${process.env.REACT_APP_LOCAL_API}/pictures/fridge/${prod.picture}`
        : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    }

    return (
      <div className="payment-product-card" key={i}>
        <img className="card-img" src={url} alt=""></img>
        <div className="payment-card-text">{prod.product_name}</div>
      </div>
    );
  });

  // 通用错误处理函数 - 发送取消指令并返回前页
  const handlePaymentError = async (errorMessage, logMessage, delay = 3000) => {
    logger(0, logMessage);
    setMessage(errorMessage);

    // 发送取消指令
    try {
      if (PAYMENT_METHOD === 'WEVEND') {
        await paymentService.cancelWeVendPayment();
      } else if (PAYMENT_METHOD === 'ISVPAY') {
        await isvpayWebSocketService.cancelTransaction();
      } else {
        await paymentService.cancelOriginalPayment();
      }
      logger(1, `${PAYMENT_METHOD} cancel sent due to error`);
    } catch (cancelError) {
      logger(0, `${PAYMENT_METHOD} cancel failed: ${cancelError.message}`);
    }

    setTimeout(() => {
      history.goBack();
    }, delay);
  };

  const cancelButton = async () => {
    if (one && allowback) {
      setone(false);

      if (PAYMENT_METHOD === 'WEVEND') {
        // WeVend 取消
        try {
          logger(1, 'WeVend payment cancelled by user');
          await paymentService.cancelWeVendPayment();
          setMessage(t('Payment cancelled'));
        } catch (error) {
          logger(0, `WeVend payment cancel failed: ${error.message}`);
          console.error('Cancel failed:', error);
        }
        setTimeout(() => {
          history.goBack();
        }, 1000);
      } else if (PAYMENT_METHOD === 'ISVPAY') {
        // ISVPay 取消
        try {
          logger(1, 'ISVPay payment cancelled by user');
          await isvpayWebSocketService.cancelTransaction();
          setMessage(t('Payment cancelled'));
        } catch (error) {
          logger(0, `ISVPay payment cancel failed: ${error.message}`);
          console.error('Cancel failed:', error);
        }
        setTimeout(() => {
          // 不断开连接，保持连接供下次使用
          history.goBack();
        }, 1000);
      } else {
        // 原有系统取消
        await paymentService.cancelOriginalPayment();
        setTimeout(() => {
          history.goBack();
        }, 3000);
      }
    }
  };

  // 处理交易进行中的错误
  const handleTransactionInProgress = async () => {
    logger(1, 'ISVPay transaction in progress detected, cancelling and returning');
    setMessage(t('Cancelling previous transaction...'));
    
    try {
      await isvpayWebSocketService.cancelTransaction();
      logger(1, 'ISVPay previous transaction cancelled');
    } catch (cancelError) {
      logger(0, `ISVPay cancel failed: ${cancelError.message}`);
    }
    
    setTimeout(() => {
      history.goBack();
    }, 2000);
  };

  // ISVPay 支付处理
  const processISVPayPayment = async () => {
    const totalAmount = localStorage.getItem('TotalPrice');

    try {
      logger(2, `ISVPay payment started - Amount: ${totalAmount}`);
      paymentService.setProcessing(true);

      // 确保连接就绪
      await isvpayWebSocketService.ensureConnection();

      // 开始支付
      const result = await isvpayWebSocketService.startSale(totalAmount, (statusData) => {
        // 处理实时状态更新
        if (statusData && (statusData.statusMessage || statusData.message)) {
          const displayMessage = statusData.statusMessage || statusData.message;
          setMessage(displayMessage);
        }
      });

      if (result.success) {
        logger(2, `ISVPay payment successful - Amount: ${totalAmount}`);
        setMessage(t('Payment successful'));
        localStorage.setItem('payment_type', 'Credit');

        const order_info_magex = JSON.parse(localStorage.getItem('order_info_magex'));
        order_info_magex.already_paid = true;

        // 发送订单创建状态
        await localRequest({
          method: 'post',
          url: '/updateKioskStatus',
          data: {
            status: 'OrderCreated',
            order_info: order_info_magex,
          },
        });

        if (result.transactionData) {
          localStorage.setItem('last_transaction', JSON.stringify(result.transactionData));
        }

        setTimeout(() => {
          history.push(`/machineUI/product-dispense/${machineID}`);
        }, 1000);
      } else {
        await handlePaymentError(
          result.message || t('Payment failed'),
          `ISVPay payment failed - Amount: ${totalAmount}, Error: ${result.message}`
        );
      }
    } catch (error) {
      // 特别处理交易进行中的错误
      if (error.message && error.message.includes('TRANSACTION_IN_PROGRESS')) {
        await handleTransactionInProgress();
        return;
      }

      // 如果是连接错误，记录事件
      if (error.message && (error.message.includes('connection') || error.message.includes('Connection'))) {
        try {
          await localRequest({
            method: 'post',
            url: '/eventsUpdate',
            data: {
              event_id: new Date().toISOString(),
              dateTime: new Date().toISOString(),
              type: 'event',
              level: 'error',
              webcode: '1171900',
              description1: `ISVPay device connection operation error`,
              description2: `Error message: ${error.message}`,
            },
          });
        } catch (eventError) {
          logger(0, `Failed to send ISVPay connection error event: ${eventError.message}`);
        }
      }

      await handlePaymentError(
        t('Payment error, returning to previous page'),
        `ISVPay payment error - Amount: ${totalAmount}, Error: ${error.message}`
      );
    } finally {
      paymentService.setProcessing(false);
    }
  };

  // WeVend 支付处理
  const processWeVendPayment = async () => {
    const totalAmount = localStorage.getItem('TotalPrice');

    try {
      logger(2, `WeVend payment started - Amount: ${totalAmount}`);

      paymentService.setProcessing(true);

      const result = await paymentService.processWeVendPayment(totalAmount, separateItem);

      if (result.success) {
        logger(2, `WeVend payment successful - Amount: ${totalAmount}`);
        setMessage(t('Payment successful'));
        localStorage.setItem('payment_type', 'Credit');
        const order_info = JSON.parse(localStorage.getItem('order_info'));
        order_info.already_paid = true;
        //send ordercreated
        await localRequest({
          method: 'post',
          url: '/updateKioskStatus',
          data: {
            status: 'OrderCreated',
            order_info: order_info,
          },
        });

        if (result.transactionData) {
          localStorage.setItem('last_transaction', JSON.stringify(result.transactionData));
        }

        setTimeout(() => {
          history.push(`/machineUI/product-dispense/${machineID}`);
        }, 1000);
      } else {
        await handlePaymentError(
          result.message || t('Payment failed'),
          `WeVend payment failed - Amount: ${totalAmount}, Error: ${result.message}`
        );
      }
    } catch (error) {
      console.error('Payment error:', error);
      await handlePaymentError(
        t('Payment error, returning to previous page'),
        `WeVend payment error - Amount: ${totalAmount}, Error: ${error.message}`
      );
    } finally {
      paymentService.setProcessing(false);
    }
  };

  // 原有支付系统的状态轮询
  const startOriginalPaymentPolling = () => {
    intervalRef.current = setInterval(async () => {
      try {
        const status = await paymentService.getOriginalPaymentStatus();

        if (status.status_message) {
          setMessage(status.status_message);
        }

        if (status.status_message === 'Authorization in progress') {
          setallowback(false);
        }

        if (status.status === 'SUCCESS') {
          clearInterval(intervalRef.current);
          localStorage.setItem('payment_type', 'Credit');

          if (status.transactionData) {
            localStorage.setItem('last_transaction', JSON.stringify(status.transactionData));
          }

          history.push(`/machineUI/product-dispense/${machineID}`);
        } else if (status.status === 'PAYMENTERROR') {
          clearInterval(intervalRef.current);
          await handlePaymentError(
            t('Payment error, back to previous page'),
            'Original payment error detected'
          );
        }

        const dataDate = new Date(status.date);
        const nowDate = new Date();
        const dif = nowDate.getTime() - dataDate.getTime();

        if (dif < 30000) {
          props.setIdle(dif);
        }
      } catch (error) {
        console.error('Failed to get payment status:', error);
      }
    }, 500);
  };

  useEffect(() => {
    if (PAYMENT_METHOD === 'WEVEND') {
      // WeVend 直接处理支付
      processWeVendPayment();

      intervalRef.current = setInterval(() => {
        idleCounterRef.current += 1;
        props.setIdle(5000 + idleCounterRef.current);
      }, 10000);
    } else if (PAYMENT_METHOD === 'ISVPAY') {
      // ISVPay 直接处理支付
      processISVPayPayment();

      intervalRef.current = setInterval(() => {
        idleCounterRef.current += 1;
        props.setIdle(5000 + idleCounterRef.current);
      }, 10000);
    } else {
      startOriginalPaymentPolling();
    }

    // 清理函数
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      // 不断开ISVPay WebSocket连接，保持持久连接
      // 只清理当前页面的消息处理器
      if (PAYMENT_METHOD === 'ISVPAY') {
        // 清理支付相关的消息处理器，但保持连接
        const handlers = ['sale', 'error', 'status'];
        handlers.forEach((handler) => {
          if (isvpayWebSocketService.messageHandlers.has(handler)) {
            isvpayWebSocketService.messageHandlers.delete(handler);
          }
        });
      }
    };
  }, []);

  return (
    <div className="payment-container">
      <div className="payment-container-div">
        <img className="payment-logo-img"></img>
        <div className="payment-products-container">{prods}</div>
        <div className="payment-line"></div>
        <div className="payment-title">{message}</div>
        {paymentMethod > 8 ? (
          <div className="payment-list2">
            <div className="payment-first-div">
              <img className="payment-visa-icon2" src={Visa} alt="" />
            </div>
            <div className="payment-first-div">
              <img className="payment-visa-icon2" src={Mastercard} alt="" />
            </div>
            {mobile_pay && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={GPay} alt="" />
              </div>
            )}
            {mobile_pay && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={ApplePay} alt="" />
              </div>
            )}
            {AE_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={AmericanExpress} alt="" />
              </div>
            )}
            {DC_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={DinersClub} alt="" />
              </div>
            )}
            {DIS_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={Discover} alt="" />
              </div>
            )}
            {JCB_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={JCB} alt="" />
              </div>
            )}
          </div>
        ) : (
          <div className="payment-list">
            <div className="payment-first-div">
              <img className="payment-visa-icon" src={Visa} alt="" />
            </div>
            <div className="payment-first-div">
              <img className="payment-visa-icon" src={Mastercard} alt="" />
            </div>
            {mobile_pay && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={GPay} alt="" />
              </div>
            )}
            {mobile_pay && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={ApplePay} alt="" />
              </div>
            )}
            {AE_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={AmericanExpress} alt="" />
              </div>
            )}
            {DC_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={DinersClub} alt="" />
              </div>
            )}
            {DIS_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={Discover} alt="" />
              </div>
            )}
            {JCB_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={JCB} alt="" />
              </div>
            )}
          </div>
        )}
        {allowback && (
          <div className="view-more-button payment-cancel-button" onClick={cancelButton}>
            {t(`CANCEL`)}
          </div>
        )}
      </div>
    </div>
  );
}
